const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    desc: '7×24小时全天候监控娱乐圈动态，热点事件发生15分钟内即完成核实与推送，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多重信源核实',
    desc: '每条爆料均经过至少三个独立信源交叉验证，拒绝谣言与假瓜，确保推送给你的每一条信息都经得起推敲。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量内容覆盖',
    desc: '涵盖影视、音乐、综艺、时尚、体育五大娱乐板块，每日更新超过200条最新八卦消息与深度分析文章。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '瓜友社群互动',
    desc: '开放评论区让千万瓜友自由讨论，投票吃瓜、话题PK、热度打榜，让你的观点被更多人看见。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步吃瓜',
    desc: 'PC端、移动网页、小程序三端实时同步，无论你在通勤路上还是摸鱼时刻，吃瓜体验不打折扣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              平台优势
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜优势
            </h2>
            <p className="text-foreground-600 text-sm max-w-xl mx-auto">
              为什么千万网友选择在吃瓜网每日大赛追八卦？五大优势告诉你答案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {features.map((f, i) => (
              <div
                key={f.title}
                className="group relative p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 hover:bg-background-100 transition-all duration-300"
              >
                <div className="absolute -top-3 -right-3 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-white text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                  {i + 1}
                </div>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-200 mb-5">
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-900 mb-2">
                  {f.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}